<template>
  <div>
    <template v-if="contentShow">
      <div class="unitCommitment">
        <div>
          <h3>订金确认</h3>
          <div class="unitTitle">付款凭证</div>
          <div>
            <template>
              <div
                class="image"
                v-if="
                  informationForm.first_payment_voucher &&
                  informationForm.first_payment_voucher.length > 0
                "
              >
                <el-image
                  :src="informationForm.first_payment_voucher"
                ></el-image>
                <div class="upload-span">
                  <span
                    class="upload-icon"
                    @click.stop="
                      handlePreview(informationForm.first_payment_voucher)
                    "
                    ><i class="el-icon-zoom-in"></i
                  ></span>
                  <span
                    class="upload-icon"
                    @click.stop="handleRemove('first_payment_voucher')"
                    style="margin-left: 20px"
                    ><i class="el-icon-delete"></i
                  ></span>
                </div>
              </div>
              <div v-else>
                <el-upload
                  action="/declare/Upload/image"
                  list-type="picture-card"
                  :headers="headers"
                  :multiple="false"
                  :on-success="
                    (response, file, fileList) => {
                      return handleSuccess(
                        response,
                        file,
                        fileList,
                        'first_payment_voucher'
                      );
                    }
                  "
                  :on-error="handleError"
                  :show-file-list="false"
                >
                  <i class="el-icon-plus">
                    <div class="uploadtxt">请上传付款凭证</div>
                  </i>
                </el-upload>
              </div>
            </template>
          </div>
          <div class="unitTitle">告知函</div>
          <div class="downloadBox">
            <div class="downloadLeft">
              <img class="pdfIcon" src="../assets/pdf.jpg" alt="" />
              <div class="unitRight">
                <div class="unittitle">告知函.pdf</div>
              </div>
            </div>
            <button class="downloadIcon" @click="down">下载</button>
          </div>
        </div>
      </div>
      <div class="footer" style="margin-top: 15px">
        <button
          v-if="
            this.informationForm.first_status != 2 &&
            this.informationForm.first_status != 1
          "
          :class="['btn', 'next', 'next_btn']"
          @click="agree"
        >
          我已汇款
        </button>
        <!--            <button-->
        <!--              v-else-->
        <!--                :class="['btn' ,'next', 'next_btn']"-->
        <!--                @click="to_next">-->
        <!--              下一步-->
        <!--            </button>-->
        <button
          v-else
          :class="['btn', 'next', 'next_btn']"
          @click="change_contentShow"
        >
          下一步
        </button>
        <!--            <button v-if="informationForm.progress==3 && informationForm.type=='2'" class="btn next_btn next"-->
        <!--                    :disabled="countdown_show"-->
        <!--                    @click="agree">已上传-->
        <!--              <span v-if="countdown_show">({{ countdown }})</span>-->
        <!--            </button>-->
      </div>
    </template>
    <template v-if="!contentShow && contentShow != null">
      <toExamine :to_examine_form="to_examine_form"></toExamine>
    </template>
    <!--预览图片 -->
    <el-dialog :visible.sync="dialogVisible" top="20vh">
      <img
        :src="dialogImageUrl"
        alt=""
        style="
          max-height: 550px;
          max-width: 100%;
          margin: 0 auto;
          display: block;
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { declareOrder_detail, swiftSubmit } from "@/api/api";
import top from "../components/top.vue";
import toExamine from "@/views/examine.vue"; //审核

export default {
  components: { toExamine },
  name: "deposit",
  data() {
    return {
      to_examine_form: {
        //
        // 1待审核  2成功  3驳回
        audit_status: 6, //审核状态
        review_text1: "请等待审核", //待审核文案
        review_text2: "已确认", //成功文案
        review_text3: "驳回", //驳回文案
      },
      contentShow: null,
      countdown: 5, //计时器
      countdown_show: true, //计时器
      headers: {
        token: localStorage.getItem("token"),
      },
      ccompanyList: JSON.parse(localStorage.getItem("ccompanyList")),
      SheetData: {},
      form_data: {},
      typeList: [
        {
          id: "1",
          name: "个人委员会",
        },
        {
          id: "2",
          name: "单位委员会",
        },
      ],
      MemberLevelList: [],
      isigned: "",
      checked: true,
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      radio: 3,
      text: "您的资料正在审核中",
      status: 1,
      committee_text_show: false, //富文本弹窗
      synopsis: "", //富文本弹窗
      brandTitle: "", //品牌弹窗名称
      brandForm: {
        //品牌表单数据
        id: "", //品牌id
        ownership: "", //所属类型 1:个人会员，2:单位会员
        user_long_id: "", //所关联的用户长ID
        brand_name: "", //品牌名称
        website: "", //品牌官网
        brand_type: "", //品牌类别
        registration_time: "", //注册时间
        registration_address: "", //注册地
        trademark: [], //商标注册证或代理授权
        category: "", //品类
        offline_store: "", //线上分布/线上店铺
        online_store: "", //入驻电商平台
        SKU: "", //年sku数
        product_price: "", //产品及价位
        honors: "", //奖项及荣誉
      },
      brandFormRules: {
        //品牌表单验证
      },
      active: 10,
      busactive: 10,
      page_no: 1,
      page_size: 10,
      total: 100,
      stepsList: [
        { title: "登记" },
        { title: "完善资料" },
        { title: "承诺书" },
        { title: "等待审核" },
        { title: "完成缴费" },
      ],
      tabList: [],
      informationForm: {
        //登记
        first_payment_voucher: "",
      },
      informationRules: {
        type: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        committee_id: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        level_long_id: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      }, //基本信息表单验证

      activeName: "basic",
      loading: false,
      dialogVisible: false, // 预览图片弹框
      dialogImageUrl: "", // 预览图片地址
      mark: "",
      result: [],
    };
  },
  mounted() {
    this.init();
  },
  created() {},
  watch: {},
  methods: {
    async init() {
      let data = this.$qs.stringify({
        declare_items_id: JSON.parse(localStorage.getItem("theSession")).id,
      });
      const res = await declareOrder_detail(data);
      this.informationForm = Array.isArray(res.data)
        ? { first_payment_voucher: "" }
        : res.data;
      if (this.informationForm.first_status) {
        this.contentShow = false;
        this.to_examine_form.audit_status = this.informationForm.first_status;
        // if(this.informationForm.first_status!=1){
        //   this.contentShow=
        // }
      } else {
        this.contentShow = true;
      }
    },
    // 内容和审核页的切换
    change_contentShow() {
      this.contentShow = !this.contentShow;
    },
    to_next() {
      this.$parent.to_next();
    },

    // 赵 定金确认
    async agree() {
      let formData = {
        declare_items_id: JSON.parse(localStorage.getItem("theSession")).id,
        first_payment_voucher: this.informationForm.first_payment_voucher,
      };
      const res = await swiftSubmit(formData);
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.init();
      } else {
        this.$message.error(res.msg);
      }
    },

    // 下载 告知函
    down() {
      let file =
        "https://oss.indata3.com/cfa/resource/file/2026%E6%98%A5%E5%AD%A3-%E6%8A%A5%E5%90%8D%E5%AE%A1%E6%A0%B8%E7%BB%93%E6%9E%9C%E5%91%8A%E7%9F%A5%E5%87%BD.pdf";
      window.open(file, "_blank");
    }, //

    // 返回
    goBack() {
      this.$router.back();
    },

    //zhao 上传成功
    handleSuccess(response, file, fileList, field) {
      if (response.code == 1) {
        // this.informationForm[field] = response.data.uri
        this.informationForm.first_payment_voucher = response.data.uri;
        this.$message.success(response.msg);
      } else {
        this.$message.error(response.msg);
      }
    },
    // zhao 上传失败
    handleError(err, file, fileList) {
      this.$message.error(err.msg);
    },
    //赵 预览图片 通用
    handlePreview(file) {
      this.dialogImageUrl = this.$imgUrl + file;
      this.dialogVisible = true;
    },
    //zhao  删除图片
    handleRemove(field) {
      this.informationForm[field] = "";
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;

  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }

  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;

    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }

  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

/deep/ .el-dialog__body {
  //height: 600px !important;
  overflow: auto;
}

.unitTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7f8fa4;
  margin: 30px 0 10px;
}

.statusBox {
  width: 749px;
  height: 100px;
  background: rgba(250, 173, 20, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.statusBox_text {
  width: 520px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.status1 {
  background: rgba(250, 173, 20, 0.1);
  color: #faad14;
}

.status2 {
  background: rgba(255, 77, 79, 0.1);
  color: #ff0000;
}

.status3 {
  background: rgba(82, 196, 26, 0.1);
  color: #52c41a;
}

.changecolor {
  cursor: pointer;

  /deep/ .el-step__line {
    background-color: rgba(228, 0, 128, 0.4);
  }

  /deep/ .el-step__head.is-wait {
    border-color: rgba(228, 0, 128, 0.4);
    color: rgba(228, 0, 128, 0.4);
  }

  /deep/ .el-step__title.is-wait {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(228, 0, 128, 0.4);
  }
}

// zhao 步骤条样式修改
.stepBox {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;

  .go-back {
    position: absolute;
    left: 0;
    top: 0;
  }

  /deep/ .el-step.is-center .el-step__line {
    left: 68%;
    right: -22%;
  }

  /deep/ .el-step__icon {
    width: 32px;
    height: 32px;
    font-size: 18px;
  }

  ///deep/ .el-step__head.is-wait {
  //  color: #C7C7CC;
  //  border-color: #C7C7CC;
  //}

  /deep/ .el-step__head.is-process {
    border-color: #e40080;
    color: #e40080;

    .el-step__line {
      background: #e40080;
    }
  }

  /deep/ .el-step__head.is-finish {
    border-color: rgba(228, 0, 128, 0.4);
    color: rgba(228, 0, 128, 0.4);

    .el-step__line {
      background: rgba(228, 0, 128, 0.4);
    }
  }

  /deep/ .el-step__title.is-finish {
    color: rgba(228, 0, 128, 0.4);
    font-size: 12px;
  }

  ///deep/ .el-step__title.is-wait {
  //  font-family: PingFangSC, PingFang SC;
  //  font-weight: 400;
  //  font-size: 12px;
  //  color: #8E8E93;
  //}

  /deep/ .el-step__title.is-process {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #e40080;
  }
}

// zhao 步骤条盒子
.stepsItem {
  width: 692px !important;
}

// zhao 基本信息表单盒子
.informationFormBox {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .bus-informationForm {
    width: 560px !important;

    /deep/ .el-select {
      width: 400px;
    }
  }

  .next {
    margin-top: 190px;
  }
}

.apply-phone {
  /deep/ .el-input__inner {
    width: 400px;
    height: 36px;
    border: 1px solid #cad2dd;
  }
}

.formBox {
  //height: 650px;
  //overflow: auto;
}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.QR_box {
  text-align: center;
}

.QR_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-align: center;
  font-style: normal;
}

.checkboxBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 94px;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eee;
}

/deep/ .el-tabs__header {
  //padding: 20px 0;
  margin: 0;
}

.tableBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.searchBtnBox {
  margin-bottom: 20px;
}

.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}

.selitem {
  width: 100%;
}

// 完成缴费
.completePaymentBox {
  width: 880px;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  margin: 20px auto 0;
  padding: 30px 20px 66px;
  box-sizing: border-box;

  .completePaymentTips {
    width: 252px;
    height: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1d1d1d;
    line-height: 20px;
    margin-bottom: 30px;
  }

  .completePaymentLine {
    width: 100%;
    height: 1px;
    background: #eeeeee;
  }

  .payInfoBox {
    display: flex;
    align-items: center;
    margin: 13px 0;

    .left {
      span {
        display: inline-block;
      }

      span:nth-child(1) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #1d1d1d;
      }

      span:nth-child(2) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #ff4d4f;
      }
    }

    .right {
      margin-left: 185px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #555555;

      .rightInfo {
        display: flex;
        margin: 10px 0;

        .rightItem {
          margin-right: 70px;
        }
      }
    }
  }

  .paytitle {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #1d1d1d;
    margin-top: 10px;
  }

  .upload-demo {
    margin-left: 26px;
    display: flex;
    margin-top: 17px;
  }

  /deep/ .el-upload-list__item {
    margin-top: 0;
  }

  .changepay {
    display: flex;
    align-items: flex-start;
  }

  .wyjf {
    margin-top: 39px;
  }

  .radioItem {
    display: inline-block;
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #eeeeee;
    margin-top: 9px;

    .radioIcon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 3px;
    }
  }

  .codeBox {
    display: flex;
    width: 345px;
    height: 116px;
    padding: 7px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #dedede;
    margin-top: 20px;

    .code {
      width: 102px;
      height: 102px;
    }

    .codeinfo {
      margin-left: 10px;

      .info1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        margin-top: 10px;
      }

      .info2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #ff4d4f;
        margin-top: 10px;
      }

      .info3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        margin-top: 16px;
      }
    }
  }
}

.upload-btn {
  width: 61px;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #ffffff;
}

.search-btn:hover {
  background: #e40080;
}

.search-btn:active {
  background: #e40080;
}

.content {
  padding-bottom: 40px;

  .main-title {
    margin-top: 40px;
    margin-bottom: 35px;
  }
}

.personageCommitment {
  padding-top: 30px;
  width: 100%;
  height: 490px;
  background: #f2f6fb;
}

.unitCommitment {
  width: 100%;
  height: 440px;
}

.downloadBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 383px;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 9px;
  border: 1px solid #cad2dd;
}

.downloadLeft {
  display: flex;
}

.downloadIcon {
  cursor: pointer;
  width: 60px;
  height: 26px;
  background: #e40080;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 10px;
  color: #ffffff;
  border: none;
}

.pdfIcon {
  width: 70px;
  height: 70px;
  border-radius: 6px;
}

.unitRight {
  margin-left: 20px;

  .unittitle {
    line-height: 68px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #2c2c2e;
  }

  .unittimes {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin: 15px 0;
  }

  .unitnum {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #999999;
  }
}
.uploadtxt {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #7f8fa4;
  margin-top: 14px;
}
.poster {
  width: 100%;
  display: block;
  margin-top: 50px;
}

/deep/ .el-dialog__footer {
  text-align: center;
}
</style>
